// Định nghĩa menu dùng chung cho Nav (sidebar) và Dashboard (lưới menu trang Tổng quan).
// Một nguồn duy nhất — sửa menu ở đây, cả hai nơi cùng cập nhật.

// `t` là hàm dịch (this.$t) truyền từ component để dùng đúng scope i18n.
export function buildMenuItems(t) {
  return [
    // ─── Tổng quan ───
    { name: t('dashboard'), href: '/', icon: 'tachometer-alt' },

    // ─── CTV sales (cộng tác viên sale) ─── nhóm riêng, chỉ 4 màn được phép xem.
    // Không thêm ctvSales vào nhóm khác để tránh lộ menu ngoài phạm vi (vd nạp tiền).
    {
      name: t('client'), href: '/client', icon: 'user-tie',
      roles: ['ctvSales'],
      items: [
        { name: t('client'), href: '/client' },
        { name: t('clientKYC'), href: '/client-kyc' },
        { name: t('kycRequest.title'), href: '/client/kyc-request' },
        { name: t('planOrder'), href: '/plan-order' },
      ],
    },

    // ─── Báo cáo ───
    {
      name: t('report'), href: "/report/customer", icon: 'chart-bar',
      roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am', 'marketingManager', 'marketing'],
      items: [
        {
          name: t('clientReport'), href: '/report/client',
          roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am', 'marketingManager']
        },
        {
          name: t('referralReport'), href: '/report/referral',
          roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am', 'marketingManager']
        },
        {
          name: t('contractReport'), href: '/report/contract',
          roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am', 'marketingManager']
        },
        {
          name: t('creditBalance'), href: '/report/credit-balance',
          roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'marketingManager']
        },
        {
          name: t('callReport'), href: '/report/call',
          roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am', 'marketingManager']
        },
        {
          name: t('callFeeOverview'), href: '/report/call-fee-overview',
          roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'marketingManager']
        },
        {
          name: t('callFeeDetail'), href: '/report/call-fee-detail',
          roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'marketingManager']
        },
        {
          name: t('callPackage'), href: '/report/call-package',
          roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'marketingManager', 'manager']
        },
        {
          name: t('planOrder'), href: '/report/plan-order',
          roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am', 'marketingManager']
        },
        {
          name: t('promotionOnOrder'), href: '/report/promotion',
          roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am', 'marketingManager']
        },
        { name: t('finance'), href: '/report/finance' },
        {
          name: t('usageReport'), href: '/report/usage',
          roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am', 'marketingManager']
        },
        {
          name: t('quantityReport'), href: '/report/quantity',
          roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am', 'marketingManager']
        },
        {
          name: t('commissionReport'), href: '/report/commission',
          roles: ['owner', 'admin', 'account', 'accountant', 'sales', 'tech', 'manager']
        },
      ]
    },

    // ─── Đối soát ───
    {
      name: t('reconciliation'), icon: 'balance-scale',
      roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager'],
      items: [
        {
          name: t('znsReconcileReport'), href: '/report/zns-reconcile',
          roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager']
        },
        {
          name: t('smsReconcileReport'), href: '/report/sms-reconcile',
          roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager']
        },
      ]
    },

    // ─── Tài chính ───
    {
      name: t('finance'), href: "/credit-deposit", icon: 'credit-card',
      roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am', 'marketingManager'],
      items: [
        { name: t('creditDeposit'), href: '/credit-deposit' },
        { name: t('creditTransaction'), href: '/credit-transaction' },
        { name: t('planOrder'), href: '/plan-order' },
        { name: t('clientPackage'), href: '/client-package' },
        { name: t('clientCDP'), href: '/client-cdp' },
        { name: t('aiAgentOrder'), href: '/client-chatbot' },
        { name: t('invoicePlanOrder'), href: '/invoice-plan-order' },
        {
          name: t('phoneNumberSetupTransaction'), href: '/phone-number-setup-transaction',
          roles: ['owner', 'admin', 'tech', 'account', 'salesAssistant', 'accountant', 'operationsManager']
        },
        {
          name: t('phoneNumberSubscriptionTransaction'), href: '/phone-number-subscription-transaction',
          roles: ['owner', 'admin', 'tech', 'account', 'salesAssistant', 'accountant', 'operationsManager']
        },
        {
          name: t('smsBrandNameRegisterTransaction'), href: '/sms-brand-name-register-transaction',
          roles: ['owner', 'admin', 'tech', 'account', 'salesAssistant', 'accountant', 'operationsManager']
        },
        {
          name: t('smsBrandNameSubscriptionTransaction'), href: '/sms-brand-name-subscription-transaction',
          roles: ['owner', 'admin', 'tech', 'account', 'salesAssistant', 'accountant', 'operationsManager']
        },
        {
          name: t('numberBrandNameSetupTransaction'), href: '/number-brand-name-setup-transaction',
          roles: ['owner', 'admin', 'tech', 'account', 'salesAssistant', 'accountant', 'operationsManager']
        },
        {
          name: t('numberBrandNameSubscriptionTransaction'), href: '/number-brand-name-subscription-transaction',
          roles: ['owner', 'admin', 'tech', 'account', 'salesAssistant', 'accountant', 'operationsManager']
        },
        {
          name: t('callRefundSubscriptionTransaction'), href: '/call-refund-subscription-transaction',
          roles: ['owner', 'admin', 'tech', 'account', 'salesAssistant', 'accountant', 'operationsManager']
        },
        {
          name: t('phoneNumberCommitTransaction'), href: '/phone-number-commit-transaction',
          roles: ['owner', 'admin', 'tech', 'account', 'salesAssistant', 'accountant', 'operationsManager']
        },
        {
          name: t('viberBrandNameCommitTransaction'), href: '/viber-brandname-commit-transaction',
          roles: ['owner', 'admin', 'tech', 'account', 'salesAssistant', 'accountant', 'operationsManager']
        },
        // Hoá đơn VAT
        { name: t('supplier'), href: '/invoice-gateway', roles: ['owner'] },
        { name: t('vatInvoice') + ' - ' + t('plan'), href: '/invoice-plan', roles: ['owner'] },
        { name: t('vatInvoice') + ' - ' + t('setup'), href: '/invoice-setup', roles: ['owner'] },
      ]
    },

    // ─── Khách hàng ───
    {
      name: t('client'), href: "/client", icon: 'user-tie',
      roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am', 'lookup', 'agency'],
      items: [
        {
          name: t('lead'), href: '/client-lead',
          roles: ['owner', 'admin', 'tech', 'sales', 'kpiSales', 'am', 'manager']
        },
        {
          name: t('clientRegister'), href: '/client-register',
          roles: ['owner', 'admin', 'tech', 'sales', 'kpiSales', 'marketing', 'marketingManager', 'manager']
        },
        { name: t('client'), href: '/client' },
        {
          name: t('invoiceInfo'), href: '/invoice-info',
          roles: ['owner', 'admin', 'tech', 'account', 'accountant']
        },

        {
          name: t('kycRequest.title'), href: '/client/kyc-request',
          roles: ['owner', 'admin', 'tech', 'operationsManager', 'sales', 'salesAssistant', 'account', 'accountant', 'am', 'manager', 'supervisor']
        },
        {
          name: 'Yêu cầu đổi TT xuất hoá đơn', href: '/client/invoice-change-request',
          roles: ['owner', 'admin', 'tech', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'account', 'accountant', 'am', 'manager', 'supervisor']
        },
        {
          name: t('clientKYC'), href: '/client-kyc',
          roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am']
        },

        {
          name: t('clientTrialExtendRequest'), href: '/client-trial-extend-request',
          roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am']
        },
        {
          name: t('plan'), href: '/plan',
          roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am']
        },
        { name: t('promotion'), href: '/promotion', roles: ['owner', 'admin', 'account'] },
        {
          name: t('callHistory'), href: '/call',
          roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'am', 'lookup']
        },
        // Ecommerce
        {
          name: t('product'), href: '/admin-product',
          roles: ['owner', 'admin', 'tech', 'operationsManager', 'account', 'am', 'sales', 'kpiSales', 'manager', 'accountant']
        },
        {
          name: t('order'), href: '/admin-order',
          roles: ['owner', 'admin', 'tech', 'operationsManager', 'account', 'am', 'sales', 'kpiSales', 'manager', 'accountant']
        },
        // Tra cứu
        {
          name: t('lookup') + ' - ' + t('adminCall'), href: '/lookup-call',
          roles: ['owner', 'admin', 'am', 'account', 'tech', 'operationsManager', 'lookup']
        },
        {
          name: t('lookup') + ' - ' + t('client'), href: '/lookup-customer',
          roles: ['owner', 'admin', 'am', 'account', 'tech', 'operationsManager', 'lookup']
        },
      ]
    },

    // ─── Viễn thông ───
    {
      name: t('phone'), href: "/host", icon: 'phone',
      roles: ['owner', 'admin', 'tech', 'account', 'operationsManager', 'am', 'marketingManager', 'sales', 'kpiSales'],
      items: [
        { name: t('phoneHost'), href: '/host', roles: ['owner', 'admin', 'tech', 'operationsManager'] },
        { name: t('gateway'), href: '/gateway', roles: ['owner', 'admin', 'tech', 'operationsManager', 'am', 'account'] },
        { name: t('phoneNetwork'), href: '/phone-network', roles: ['owner', 'admin', 'tech', 'operationsManager', 'am', 'account'] },
        { name: t('phoneNumber'), href: '/number' },
        { name: 'DNC', href: '/dnc', roles: ['owner', 'admin', 'tech', 'operationsManager'] },
        { name: t('systemRecording'), href: '/system-recording', roles: ['owner', 'admin', 'tech', 'operationsManager'] },
        // Phát hiện lỗi
        {
          name: t('faultDetection') + ' - ' + t('keyword'), href: '/fault-detection-keyword',
          roles: ['owner', 'admin', 'tech', 'account', 'operationsManager', 'am', 'sales', 'kpiSales']
        },
        {
          name: t('faultDetection') + ' - ' + t('callFaultDetection'), href: '/fault-detection-call',
          roles: ['owner', 'admin', 'tech', 'account', 'operationsManager', 'am', 'sales', 'kpiSales']
        },
        {
          name: t('faultDetection') + ' - Chat', href: '/fault-detection-chat',
          roles: ['owner', 'admin', 'tech', 'account', 'operationsManager', 'am']
        },
        {
          name: t('faultDetection') + ' - IP', href: '/fault-detection-ip',
          roles: ['owner', 'admin', 'tech', 'account', 'operationsManager', 'am', 'sales', 'kpiSales']
        },
      ]
    },

    // ─── Chiến dịch & Tin nhắn ───
    {
      name: t('campaign') + ' & ' + t('message'), icon: 'rocket',
      roles: ['owner', 'admin', 'tech', 'account', 'operationsManager', 'am', 'marketingManager', 'ctvCall'],
      items: [
        // Chiến dịch
        {
          name: t('massCall'), href: '/call-campaign',
          roles: ['owner', 'admin', 'tech', 'account', 'operationsManager', 'am', 'marketingManager']
        },
        {
          name: t('messageCampaign'), href: '/message-campaign',
          roles: ['owner', 'admin', 'tech', 'operationsManager', 'account', 'am']
        },
        { name: t('emailCampaign'), href: '/email-campaign' },
        // Tin nhắn
        { name: 'SMS', href: '/sms' },
        { name: 'Viber', href: '/viber' },
        { name: 'ZBS', href: '/zns' },
        { name: t('socialNetworkAccounts'), href: '/social-network-account' },
        { name: t('clientBot'), href: '/client-bot', roles: ['owner', 'admin', 'tech', 'account', 'am'] },
        // Email Marketing
        { name: t('emailTemplate'), href: '/email-template-callio' },
        { name: 'Email Sender', href: '/email-sender' },
        // Gọi tự động
        {
          name: t('aiAdminCall') + ' - ' + t('report'), href: '/admin-call-report',
          roles: ['owner', 'admin', 'tech', 'account', 'operationsManager']
        },
        {
          name: t('aiAdminCall') + ' - ' + t('adminCall'), href: '/admin-call',
          roles: ['owner', 'admin', 'tech', 'account', 'operationsManager']
        },
        {
          name: t('aiAdminCall') + ' - ' + t('adminCalltranslate'), href: '/admin-call-translate',
          roles: ['owner', 'admin', 'tech', 'account', 'operationsManager', 'ctvCall', 'am']
        },
      ]
    },

    // ─── AI ───
    {
      name: 'AI', icon: 'robot',
      roles: ['owner', 'admin', 'tech', 'account', 'operationsManager'],
      items: [
        { name: 'AI Trợ lý - Tổng quan', href: '/ai-assistant' },
        { name: 'AI Trợ lý - Nhật ký', href: '/ai-assistant-logs' },
        { name: 'AI Agent - Tổng quan', href: '/ai-agent' },
        { name: 'AI Agent - Nhật ký', href: '/ai-agent-logs' },
        { name: 'AI Agent - Billing Overview', href: '/ai-agent-overview' },
        { name: 'AI Gateway', href: '/ai-gateway' },
      ]
    },

    // ─── Đối tác (white-label) ───
    {
      name: 'Đối tác', icon: 'handshake',
      roles: ['owner', 'admin', 'tech', 'agency', 'account', 'accountant'],
      items: [
        { name: 'Cài đặt', href: '/partner-domain', roles: ['owner', 'admin', 'tech', 'agency'] },
        { name: 'Nạp hạn mức', href: '/partner-credit', roles: ['owner', 'admin', 'agency', 'account', 'accountant'] },
        { name: 'Báo cáo', href: '/agency-report', roles: ['owner', 'admin', 'agency', 'account', 'accountant'] },
      ]
    },

    // ─── Cài đặt (gom Nhân viên + Token) ───
    {
      name: t('setup'), icon: 'cogs',
      // 'agency' để hiện nhóm Cài đặt — agency chỉ thấy item Token (các item khác có roles loại agency).
      roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'am', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager', 'agency'],
      items: [
        // Nhân viên
        {
          name: t('adminUser'), href: '/admin-user',
          roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager']
        },
        {
          name: t('setupKPI'), href: '/admin-user-kpi',
          roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager']
        },
        {
          name: t('department'), href: '/department',
          roles: ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'sales', 'kpiSales', 'salesAssistant', 'supervisor', 'manager']
        },
        { name: 'Category', href: '/category', roles: ['owner', 'admin'] },
        // Cài đặt hệ thống
        { name: t('logisticsCompany'), href: '/carrier-gateway', roles: ['owner', 'admin', 'tech'] },
        { name: t('printTemplate'), href: '/print-template', roles: ['owner', 'admin', 'tech'] },
        { name: t('country'), href: '/country', roles: ['owner', 'admin', 'tech'] },
        { name: t('parameter'), href: '/etc', roles: ['owner', 'admin', 'tech', 'account'] },
        { name: 'Popup', href: '/admin-popup', roles: ['owner', 'admin', 'tech'] },
        { name: 'Release Notes', href: '/release-note', roles: ['owner', 'admin', 'tech'] },
        { name: t('mappingZaloUser'), href: '/mapping-zalo-user', roles: ['owner', 'admin', 'tech'] },
        { name: 'Token', href: '/token' },
      ]
    },



    // ─── Công cụ ───
    {
      name: t('tools'), icon: 'tools',
      roles: ['owner', 'admin', 'tech', 'account', 'operationsManager', 'am', 'manager'],
      items: [
        { name: t('utility'), href: '/tool', roles: ['owner', 'admin', 'tech', 'account', 'am', 'manager'] },
        { name: t('taxCodeInfoMenu'), href: '/tax-code-info', roles: ['owner', 'admin', 'tech', 'account', 'am', 'manager'] },
        {
          name: t('diagnosticReport'), href: '/diagnostic',
          roles: ['owner', 'admin', 'tech', 'account', 'operationsManager', 'am']
        },
        {
          name: t('callDiagnostic'), href: '/diagnostic/call',
          roles: ['owner', 'admin', 'tech', 'account', 'operationsManager', 'am']
        },
        {
          name: t('coldLake'), href: '/cold-lake',
          roles: ['owner', 'admin', 'tech']
        },
        {
          name: t('deployProduction'), href: '/deploy-production',
          roles: ['owner', 'admin', 'tech']
        },
      ]
    },

    // ─── Nhật ký (gom tất cả log) ───
    {
      name: t('logs'), icon: 'history',
      roles: ['owner', 'admin', 'tech', 'account', 'operationsManager', 'am'],
      items: [
        { name: t('logCustomerActivity'), href: '/activity-history', roles: ['owner', 'admin', 'tech', 'account'] },
        { name: t('logSocialAccountChange'), href: '/social-network-account-history' },
        { name: t('logChatSession'), href: '/chat-history' },
        { name: t('logEmailSent'), href: '/email-history' },
        { name: t('logSystemEmail'), href: '/system-email-history', roles: ['owner', 'admin', 'tech'] },
        { name: t('logBotDetect'), href: '/bot-detect-history' },
        { name: t('logPointTransaction'), href: '/point-transaction-history' },
        { name: t('logWebhookVietguys'), href: '/webhook-vietguys', roles: ['owner', 'admin', 'tech', 'account', 'am'] },
        { name: t('logHiloInvoice'), href: '/hilo-invoice-log', roles: ['owner'] },
        { name: t('logSocialWebhook'), href: '/social-webhook-log', roles: ['owner', 'admin', 'tech'] },
        { name: t('geoAddressMenu'), href: '/geo-address', roles: ['owner', 'admin', 'tech'] },
      ]
    },
  ];
}

// Kiểm tra role hiện tại có nằm trong danh sách roles của menu item không.
// roles rỗng/không khai báo → ai cũng xem được.
export function checkMenuRole(roles, userRole) {
  if (!roles || roles.length === 0) return true;
  return roles.indexOf(userRole) !== -1;
}

// i18n keys của menu — dùng chung cho Nav và Dashboard.
export const menuMessages = {
  en: {
    promotions: 'Promotion',
    dashboard: 'Dashboard',
    client: 'Client',
    clientRegister: 'Client register',
    clientKYC: 'Client KYC',
    callFeeOverview: 'Call fee overview',
    callFeeDetail: 'Call fee detail',
    plan: 'Plan',
    creditDeposit: 'Credit deposit',
    phoneNumber: 'Phone numbers',
    phoneHost: 'Phone hosts',
    country: 'Country',
    phoneNetwork: 'Phone network',
    adminUser: 'Admin users',
    profile: 'My profile',
    changePassword: 'Change password',
    logOut: 'Logout',
    systemRecording: 'System recording',
    creditTransaction: 'Credit transaction',
    report: "Report",
    clientReport: "Client",
    systemUsageReport: "System Usage",
    financeReport: "Finance",
    callReport: "Call",
    diagnosticReport: "Performance diagnostic",
    callDiagnostic: "Call diagnostic",
    coldLake: "Cold Lake",
    deployProduction: "Deploy Production",
    tools: "Tools",
    utility: "Utility",
    taxCodeInfoMenu: "Tax code lookup",
    geoAddressMenu: "Address dictionary",
    callTrafficReport: "Call traffic",
    customerReport: "Customer",
    sms: "SMS",
    emailMarketing: "Email",
    planOrder: "Plan order",
    subscriptionTransaction: "Subscription",
    callHistory: 'Call history',
    campaign: 'Campaign',
    smsHistory: 'SMS history',
    znsHistory: 'ZBS history',
    phoneNumberSetupTransaction: 'Phone number setup transaction',
    smsBrandNameRegisterTransaction: 'SMS brand name register transaction',
    phoneNumberSubscriptionTransaction: 'Phone number subscription transaction',
    smsBrandNameSubscriptionTransaction: 'SMS brand name subscription transaction',
    numberBrandNameSetupTransaction: 'Number brand name setup transaction',
    numberBrandNameSubscriptionTransaction: 'Number braVnd name subscription transaction',
    commissionConfig: 'Commission config',
    role: 'Role',
    department: 'Department',
    kpiSetup: 'KPI setup',
    commission: 'Commission',
    commissionList: 'Commission list',
    adminUserCommission: 'Employee commission',
    zns: 'ZBS',
    znsSupplier: 'ZBS Supplier',
    znsTemplate: 'ZBS Template',
    phone: 'Tele Phone',
    aiAPP: "AI APP",
    aiCall: "Auto call",
    aiTemplate: 'Call Template',
    cluster: "Cluster",
    flex: "Flex Package",
    faultDetection: "Fault Detection",
    callFaultDetection: "Suspicious call",
    keyword: "Keyword",
    viber: "Viber",
    viberHistory: "Viber history",
    creditBalance: "Credit Balance",
    message: "Message",
    messageCampaign: "Message campaign",
    phonebook: 'Phonebook',
    aiHistory: "History",
    contractReport: "Contract",
    parameter: "Parameter",
    emailCampaign: "Email Campaign",
    setupKPI: "Setup KPI",
    setup: "Setup",
    promotionOnOrder: "Promotion on orders",
    lead: 'Lead',
    emailTemplate: 'Template',
    phoneNumberCommitTransaction: "Phone number commit transaction",
    viberBrandNameCommitTransaction: "Viber brandName commit transaction",
    massCall: "Mass call",
    clientCDP: "CDP package",
    marketingManager: "Marketing Manager",
    referralReport: "Referral",
    emailHistory: "Email history",
    socialNetworkAccounts: "Social network account",
    planOrderByMonth: "Plan order by month",
    usageReport: 'Usage',
    callPackage: 'All-inclusive calling package',
    order: 'Order',
    printTemplate: 'Print template',
    logisticsCompany: 'Logistics company',
    chatSession: "Chat session",
    chatFaultDetection: "Suspicious chat",
    quantityReport: "Quantity",
    mappingZaloUser: 'List of personal Zalo customers',
    callRefundSubscriptionTransaction: "Refund of call charges",
    activityHistory: "Activity history",
    logs: "Logs",
    logCustomerActivity: "Customer activity",
    logSocialAccountChange: "Social account changes",
    logChatSession: "Chat sessions",
    logEmailSent: "Sent emails",
    logSystemEmail: "System emails",
    logBotDetect: "Bot detection",
    logPointTransaction: "Point transactions",
    logAiAssistant: "AI Assistant",
    logAiAgent: "AI Agent",
    logWebhookVietguys: "Webhook Vietguys",
    logHiloInvoice: "Hilo VAT invoice API",
    logSocialWebhook: "Social network webhook",
    product: "Product",
    aiAdminCall: "Xử lý cuộc gọi AI",
    adminCall: "Cuộc gọi",
    adminCalltranslate: "Biên dịch",
    lookup: "Tra cứu",
    kpiSales: "KPI sales",
    ctvSales: "Sales collaborator",
    aiAgentOrder: "AI agent order",
    clientBot: "Client Bot",
    socialNetworkAccountsHistory: "Social network account history",
    botDetectHistory: "Bot detect history",
    pointTransactionHistory: "Point transaction history",
    chatHistory: "Chat history",
    invoiceInfo: "Invoice info",
    vatInvoice: "Electronic invoice",
    supplier: "Supplier",
    invoicePlanOrder: "Electronic invoice order",
    ipFaultDetection: "Suspicious customers",
    commissionReport: "Sales commission report",
    znsReconcileReport: "ZBS reconciliation",
    smsReconcileReport: "SMS reconciliation",
    reconciliation: "Reconciliation",
  },
  vi: {
    promotion: 'Khuyến mãi',
    keyword: 'Từ khóa',
    dashboard: 'Tổng quan',
    client: 'Khách hàng',
    clientRegister: 'Đăng ký dùng thử',
    clientKYC: 'Hồ sơ khách hàng',
    callFeeOverview: 'Cước gọi tổng quan',
    callFeeDetail: 'Cước gọi chi tiết',
    plan: 'Gói dịch vụ',
    creditDeposit: 'Lệnh nạp tiền',
    phoneNumber: 'Số điện thoại',
    phoneHost: 'Tổng đài',
    country: 'Quốc gia',
    phoneNetwork: 'Mạng',
    adminUser: 'Tài khoản',
    profile: 'Hồ sơ cá nhân',
    changePassword: 'Đổi mật khẩu',
    logOut: 'Thoát tài khoản',
    systemRecording: 'File ghi âm',
    creditTransaction: 'Lịch sử giao dịch',
    report: "Báo cáo",
    clientReport: "Khách hàng",
    systemUsageReport: "Sử dụng hệ thống",
    financeReport: "Tài chính",
    callReport: "Cuộc gọi",
    diagnosticReport: "Chẩn đoán hiệu năng",
    callDiagnostic: "Chẩn đoán cuộc gọi",
    coldLake: "Cold Lake (data cũ)",
    deployProduction: "Triển khai Production",
    tools: "Công cụ",
    utility: "Tiện ích",
    taxCodeInfoMenu: "Tra cứu mã số thuế",
    geoAddressMenu: "Từ điển địa chỉ",
    callTrafficReport: "Lưu lượng gọi",
    customerReport: "Khách hàng",
    sms: "SMS",
    emailMarketing: "Email",
    planOrder: "Đơn hàng gói dịch vụ",
    subscriptionTransaction: "Thuê bao hàng tháng",
    callHistory: 'Lịch sử gọi',
    campaign: 'Chiến dịch',
    smsHistory: 'Lịch sử SMS',
    znsHistory: 'Lịch sử ZBS',
    phoneNumberSetupTransaction: 'Phí khởi tạo số',
    smsBrandNameRegisterTransaction: 'Phí đăng ký SMS brandname',
    phoneNumberSubscriptionTransaction: 'Phí duy trì số',
    smsBrandNameSubscriptionTransaction: 'Phí duy trì brandname',
    numberBrandNameSetupTransaction: 'Phí khởi tạo brandname số',
    numberBrandNameSubscriptionTransaction: 'Phí duy trì brandname số',
    commissionConfig: 'Cài đặt hoa hồng',
    role: 'Phân quyền',
    department: 'Phòng ban',
    kpiSetup: 'Cài đặt KPI',
    commission: 'Hoa hồng',
    commissionList: 'Danh sách chi tiết',
    adminUserCommission: 'Hoa hồng nhân viên',
    zns: 'ZBS',
    znsSupplier: 'Nhà cung cấp ZBS',
    znsTemplate: 'Mẫu tin nhắn ZBS',
    phone: 'Điện thoại',
    aiAPP: "Bot gọi",
    aiCall: "Gọi tự động",
    aiTemplate: 'Mẫu cuộc gọi',
    cluster: "Cluster",
    flex: "Gói Flex",
    faultDetection: "Vi phạm",
    callFaultDetection: "Cuộc gọi nghi ngờ",
    viber: "Viber",
    viberHistory: "Lịch sử Viber",
    creditBalance: "Số dư khách hàng",
    message: "Tin nhắn",
    messageCampaign: "Chiến dịch tin nhắn",
    phonebook: 'Danh bạ số',
    aiHistory: "Lịch sử",
    contractReport: "Hợp đồng",
    parameter: "Tham số",
    emailCampaign: "Chiến dịch email",
    setupKPI: "Cài đặt KPI",
    setup: "Cài đặt",
    promotionOnOrder: "Khuyến mãi trên đơn hàng",
    lead: 'Tiềm năng',
    emailTemplate: 'Mẫu email',
    phoneNumberCommitTransaction: "Số điện thoại cam kết",
    viberBrandNameCommitTransaction: "Viber brandname cam kết ",
    massCall: "Gọi hàng loạt",
    clientCDP: "Đơn hàng gói CDP",
    marketingManager: "Quản lý Marketing",
    referralReport: "Giới thiệu",
    emailHistory: "Lịch sử email",
    socialNetworkAccounts: "Tài khoản mạng xã hội",
    planOrderByMonth: "Đơn hàng",
    usageReport: 'Sử dụng',
    callPackage: 'Gói gọi trọn gói',
    order: 'Đơn hàng',
    printTemplate: 'Mẫu in',
    logisticsCompany: 'Hãng vận chuyển',
    chatSession: "Phiên chat",
    chatFaultDetection: "Tin nhắn nghi ngờ",
    quantityReport: "Sản lượng",
    mappingZaloUser: "Danh sách KH Zalo cá nhân",
    callRefundSubscriptionTransaction: "Hoàn tiền cước gọi",
    activityHistory: "Lịch sử hoạt động",
    logs: "Nhật ký",
    logCustomerActivity: "Hoạt động khách hàng",
    logSocialAccountChange: "Tài khoản MXH — Thay đổi",
    logChatSession: "Phiên chat",
    logEmailSent: "Email đã gửi",
    logSystemEmail: "Email hệ thống",
    logBotDetect: "Phát hiện bot",
    logPointTransaction: "Giao dịch điểm",
    logAiAssistant: "AI Trợ lý",
    logAiAgent: "AI Agent",
    logWebhookVietguys: "Webhook Vietguys",
    logHiloInvoice: "API Hoá đơn VAT Hilo",
    logSocialWebhook: "Nhật ký MXH",
    product: "Sản phẩm",
    aiAdminCall: "Xử lý cuộc gọi AI",
    adminCall: "Cuộc gọi",
    adminCalltranslate: "Biên dịch",
    lookup: "Tra cứu",
    kpiSales: "KPI sales",
    ctvSales: "Cộng tác viên sale",
    aiAgentOrder: "Đơn hàng nhân viên AI",
    clientBot: "Tài khoản tích hợp",
    socialNetworkAccountsHistory: "Lịch sử tài khoản mạng xã hội",
    botDetectHistory: "Lịch sử giám sát giao tiếp",
    pointTransactionHistory: "Lịch sử tích điểm",
    chatHistory: "Lịch sử chat",
    invoiceInfo: "Thông tin xuất hóa đơn",
    vatInvoice: "Hoá đơn điện tử",
    supplier: "Nhà cung cấp",
    invoicePlanOrder: "Đơn hàng hoá đơn điện tử",
    ipFaultDetection: "Khách hàng nghi ngờ",
    commissionReport: "Báo cáo hoa hồng sales",
    znsReconcileReport: "Đối soát ZBS",
    smsReconcileReport: "Đối soát SMS",
    reconciliation: "Đối soát",
  }
};
